import { node } from 'prop-types';
import React, { useEffect, useState } from 'react';
import SwitchTestContext from '../../contexts/SwitchTestContext';
import { getDigitalDataSubscriptionPromise } from '../../tools/getDigitalDataSubscriptionPromise';
import { FEATURE_SWITCHES } from '../../tools/constants';

const SwitchTestProvider = ({ children }) => {
  const keys = FEATURE_SWITCHES;
  const [digitalData, setDigitalData] = useState({});

  useEffect(() => {
    if (window.digitalData) {
      keys.forEach((key) => {
        getDigitalDataSubscriptionPromise(key, 5000).then((value) => {
          setDigitalData((currentState) => ({
            ...currentState,
            [key]: value,
          }));
        }).catch(() => {
          // noop
        });
      });
    }
  }, [keys]);

  return (
    <SwitchTestContext.Provider value={digitalData}>
      {children}
    </SwitchTestContext.Provider>
  );
};

SwitchTestProvider.propTypes = {
  children: node.isRequired,
};

export default SwitchTestProvider;
